import React from "react";

class Mac_App_Authorize extends React.Component {
    render() {
        return (
            <iframe
                src={this.props.args.download_url}
                className="hidden"
                width="0"
                height="0"
            />
        );
    }
}

export default Mac_App_Authorize;
